import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import TextInput from "../../common/TextInput";
import ValidationGroup from "../../common/ValidationGroup";
import DateInput from "../../common/DateInput";
import SelectInput from "../../common/SelectInput";
import JaNeeRadioButtonGroup from "../../common/JaNeeRadioButtonGroup";
import Row from "../../common/Row";
import Col from "../../common/Col";
import ContactpersoonComponent from "./ContactpersoonComponent";
import GemeenteComponent from "./GemeenteComponent";
import { Landen, FederatieDropdown } from "../../../constants/DomainConstants";
import AutoComplete from "../../common/AutoComplete";
import Section from "../../common/Section";
import * as types from "../../../constants/ComponentConstants";
import Button from "../../common/Button";
import Confirm from "../../common/Confirm";

const TochtForm = (props) => {
    const {
        model,
        onChange,
        onDatumChange,
        onLandChange,
        onContactpersoonChange,
        onTochtTypeChange,
        onAangeslotenBijChange,
        onTochtNietViaFederatieChange,
        onContactpersoonLandChange,
        onChangeGemeente,
        onAddGemeente,
        onRemoveGemeente,
        errors,
        federaties,
        tochtTypes,
        landen,
        postcodes,
        gemeenten,
        hoofdgemeenten,
        disabled,
        onSave,
        onAnnuleer,
        onChangeContactpersoonSelection,
        contactpersonen,
        selectedContactpersoon,
        validationMessageType,
        dagenNodigVoorMachtiging,
        onHandleOpenKopieerGegevensTochtModal,
        organisatorHadAlFederatie,
        showTeLaatPopup,
        onConfirmTeLaatPopup
    } = props;

    const tochtTypeGekozen = !!model.tochtTypeId;
    const relevanteFederaties = federaties.filter(f => f.tochtTypeId === model.tochtTypeId);
    const geenRelevanteFederaties = tochtTypeGekozen && relevanteFederaties.length === 0;
    const aangeslotenBijItems = [...relevanteFederaties, { value: FederatieDropdown.NIET_AANGESLOTEN, label: "Niet aangesloten" }];
    const aangeslotenBijValue = model.nietAangeslotenBij || (!organisatorHadAlFederatie && geenRelevanteFederaties)
        ? FederatieDropdown.NIET_AANGESLOTEN
        : model.aangeslotenBij;
    const isStartplaatsInBelgie = model.startplaatsLand === Landen.BELGIE;
    const aangeslotenFederatie = model.aangeslotenBij ? federaties.find(f => f.value === model.aangeslotenBij) : null;
    const federatieTochtTypeMatch = aangeslotenFederatie != null && aangeslotenFederatie.tochtTypeId === model.tochtTypeId;
    const itjeBewaarknopTekst = aangeslotenFederatie && !aangeslotenFederatie.tochtenAutomatischGoedkeuren && model.viaFederatie !== false && federatieTochtTypeMatch
        ? `Nadat je op “bewaar” hebt gedrukt, is jouw aanvraag klaar voor goedkeuring door ${aangeslotenFederatie.label}. Om het automatisch proces van de aanvraag tot beoordeling door de betrokken instanties in gang te zetten moet het dossier op de volgende pagina’s verder aangevuld worden.`
        : "Om het automatisch proces van de aanvraag tot beoordeling door de betrokken instanties in gang te zetten, moet het dossier op de volgende pagina’s verder aangevuld worden.";
    function handleOnChangeGemeente(i) {
        return function (event) {
            onChangeGemeente(i, event);
        };
    }

    function handleOnRemoveGemeente(i) {
        return function (event) {
            onRemoveGemeente(i, event);
        };
    }

    const gemeenteIds = model.gemeenten.map(a => a);

    const gemeentesDoorritToertocht = model.gemeenten.map((gemeente, index) => {
        const gemeenteErrors = errors ? errors['gemeente_' + index] : null;

        const gemeentenVoorComponent = hoofdgemeenten.filter(x => !gemeenteIds.includes(x.value) || gemeente === x.value);
        const id = "gemeente_" + index;
        return (
            <GemeenteComponent
                key={id}
                gemeente={gemeente}
                minButtonEnabled={model.gemeenten.length > 1}
                plusButtonEnabled={index == model.gemeenten.length - 1}
                hoofdgemeenten={gemeentenVoorComponent}
                disabled={disabled}
                onPlusButtonClick={onAddGemeente}
                onMinButtonClick={handleOnRemoveGemeente(index)}
                onChange={handleOnChangeGemeente(index)}
                index={index}
                validationMessageType={validationMessageType}
                errors={gemeenteErrors}
            />
        );
    });

    return (
        <Section title={"Vul de gegevens van de tocht in"} color={types.COLOR_BLUE}>
            {showTeLaatPopup
                ? <Confirm
                    message={""}
                    title={"Opgelet"}
                    callback={onConfirmTeLaatPopup}
                    confirmText="OK"
                    hideCancel>
                    <p>Tochten die op minder dan {dagenNodigVoorMachtiging} dagen voor de start aangemaakt worden zijn te laat voor het aanvragen van toelatingen bij <b>het ANB en het AWV</b>. Deze instanties kunnen helaas <b>geen toelating</b> meer verlenen. Dit betekent dat je tocht niet op hun grondgebied mag lopen.</p>
                    <p>Zodra je dossier volledig is ingevuld, kunnen de betrokken gemeenten en steden eventueel nog toelating verlenen. Dit is afhankelijk van de behandelingstermijn die de gemeenten en steden hanteren.</p>
                </Confirm>
                : null}
            <Form
                name="tochtForm"
                title={"Invulformulier nieuwe tocht"}
                headerVisible={false}
                leftButtonLabel={"Bewaar"}
                leftButtonDisabled={disabled}
                onLeftButtonClick={onSave}
                tooltipLeftButton={itjeBewaarknopTekst}
                tooltipWindowWidthLeftButton={30}
                rightButtonLabel={"Annuleer"}
                onRightButtonClick={onAnnuleer}>
                <Fieldset>
                <Col>

                    { model.idToCloneFullTocht == null ? <Button
                            text={"Overnemen algemene gegevens van andere tocht"}
                            onClick={onHandleOpenKopieerGegevensTochtModal}
                            style={{ marginBottom: 20 }}
                        /> : null}

                        <SelectInput
                            name="tochtTypeId"
                            label="Soort tocht"
                            items={tochtTypes}
                            onChange={onTochtTypeChange}
                            disabled={disabled || model.idToCloneFullTocht != null}
                            validationMessage={errors ? errors['tochtTypeId'] : ""}
                            validationMessageType={validationMessageType}
                            value={model.tochtTypeId}
                        />

                </Col>

                <Col>
                </Col>


                </Fieldset>

                <Fieldset title="Organisator">
                    <Col>
                        <TextInput
                            name="organisatorNaam"
                            label="Naam"
                            value={model.organisatorNaam}
                            onChange={onChange}
                            disabled
                            validationMessage={errors ? errors['organisatorNaam'] : ""}
                            validationMessageType={validationMessageType}
                        />
                    </Col>
                    {model.organisatorIsFederatie
                        ? null
                        : <Col>
                            <SelectInput
                                name="aangeslotenBij"
                                label={organisatorHadAlFederatie ? "Aangesloten bij" : "Voor deze tocht aangesloten bij"}
                                items={organisatorHadAlFederatie ? federaties : aangeslotenBijItems}
                                onChange={onAangeslotenBijChange}
                                disabled={disabled || organisatorHadAlFederatie || !tochtTypeGekozen || geenRelevanteFederaties}
                                value={aangeslotenBijValue}
                                validationMessage={errors ? errors['aangeslotenBij'] : ""}
                                validationMessageType={validationMessageType}
                            />
                        </Col>
                    }
                    {!model.organisatorIsFederatie && organisatorHadAlFederatie && tochtTypeGekozen && federatieTochtTypeMatch && !aangeslotenFederatie.tochtenAutomatischGoedkeuren
                        ? <Col size={12}>
                            <JaNeeRadioButtonGroup
                                label="Ik organiseer deze tocht onafhankelijk zonder beroep te doen op ondersteuning van de federatie (verzekering/kalender, …)"
                                name="tochtNietViaFederatie"
                                value={model.viaFederatie == null ? null : !model.viaFederatie}
                                onChange={onTochtNietViaFederatieChange}
                                disabled={disabled}
                                validationMessage={errors ? errors['viaFederatie'] : ""}
                                validationMessageType={validationMessageType}
                                horizontal
                                tooltip={"Deze tocht wordt niet opgenomen in de kalender van de federatie en wordt niet verzekerd door de federatie."}
                            />
                        </Col>
                        : null
                    }
                </Fieldset>
                <ContactpersoonComponent
                    model={model.contactpersoon}
                    landen={landen}
                    postcodes={postcodes}
                    gemeenten={gemeenten}
                    onChange={onContactpersoonChange}
                    onLandChange={onContactpersoonLandChange}
                    onChangeContactpersoonSelection={onChangeContactpersoonSelection}
                    selectedContactpersoon={selectedContactpersoon}
                    contactpersonen={contactpersonen}
                    disabled={disabled}
                    errors={errors ? errors['contactpersoon'] : null}
                    validationMessageType={validationMessageType}
                />
                <Fieldset title={"Tocht"}>
                    <Row>
                        <TextInput
                            name="naam"
                            size={6}
                            label={"Naam tocht"}
                            value={model.naam}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['naam'] : ""}
                            validationMessageType={validationMessageType} />
                        <DateInput
                            name="datum"
                            label={"Datum tocht"}
                            size={6}
                            value={model.datum}
                            onChange={onDatumChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['datum'] : ""}
                            validationMessageType={validationMessageType} />
                    </Row>
                </Fieldset>

                <Fieldset title={"Startplaats van de tocht"}>
                    <Row>
                        <SelectInput
                            name="startplaatsLand"
                            value={model.startplaatsLand}
                            label="Land van de startplaats"
                            size={6}
                            items={landen}
                            onChange={onLandChange}
                            disabled={disabled}
                            validationMessage={errors ? errors["startplaatsLand"] : ""}
                            validationMessageType={validationMessageType} />

                        {isStartplaatsInBelgie ?
                            <AutoComplete
                                name="startplaatsPostcode"
                                label="Gemeente van de startplaats"
                                size={6}
                                items={gemeenten}
                                onChange={onChange}
                                disabled={disabled}
                                value={model.startplaatsPostcode}
                                validationMessage={errors ? errors["startplaatsPostcode"] : ""}
                                validationMessageType={validationMessageType}
                            />
                            :
                            <TextInput
                                name="startplaatsGemeenteNietBelgie"
                                label="Gemeente van de startplaats"
                                size={6}
                                onChange={onChange}
                                disabled={disabled}
                                value={model.startplaatsGemeenteNietBelgie}
                                validationMessage={errors ? errors['startplaatsGemeenteNietBelgie'] : ""}
                                validationMessageType={validationMessageType} />
                        }
                    </Row>
                </Fieldset>
                <ValidationGroup messages={errors && errors["startplaatsen_verplicht"] ? errors["startplaatsen_verplicht"] : undefined} type={validationMessageType}>
                    <Fieldset title={"Hoofdgemeente(n) in Vlaanderen waardoor de tocht loopt"} tooltip="Gelieve ook de startplaats, als deze in Vlaanderen ligt, op te nemen in deze lijst." tooltipWindowWidth={30}>
                        {gemeentesDoorritToertocht}
                    </Fieldset>
                </ValidationGroup>
            </Form>


        </Section>);
};

TochtForm.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onDatumChange: PropTypes.func.isRequired,
    onLandChange: PropTypes.func.isRequired,
    onContactpersoonChange: PropTypes.func.isRequired,
    onTochtTypeChange: PropTypes.func,
    onAangeslotenBijChange: PropTypes.func,
    onTochtNietViaFederatieChange: PropTypes.func,
    onContactpersoonLandChange: PropTypes.func.isRequired,
    onChangeGemeente: PropTypes.func.isRequired,
    onAddGemeente: PropTypes.func.isRequired,
    onRemoveGemeente: PropTypes.func.isRequired,
    errors: PropTypes.object,
    federaties: PropTypes.array,
    tochtTypes: PropTypes.array,
    landen: PropTypes.array,
    postcodes: PropTypes.array,
    gemeenten: PropTypes.array,
    hoofdgemeenten: PropTypes.array,
    disabled: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onAnnuleer: PropTypes.func.isRequired,
    onChangeContactpersoonSelection: PropTypes.func.isRequired,
    selectedContactpersoon: PropTypes.string,
    contactpersonen: PropTypes.array,
    validationMessageType: PropTypes.string,
    dagenNodigVoorMachtiging: PropTypes.number,
    onHandleOpenKopieerGegevensTochtModal:PropTypes.func.isRequired,
    organisatorHadAlFederatie: PropTypes.bool,
    showTeLaatPopup: PropTypes.bool,
    onConfirmTeLaatPopup: PropTypes.func,
};

export default TochtForm;